module.exports = __webpack_public_path__ + "img/logo-minsterio-educacion-formacion-profecional-deportes-amarillo.1c96bb29.jpg";